import 'bootstrap/dist/css/bootstrap.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '@/sass/main.sass';

import 'bootstrap';
import 'slick-carousel/slick/slick';
import 'babel-polyfill';
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueGtag from 'vue-gtag';
import App from './App.vue';
import store from './vuex/store';
import router from './router';

Vue.use(VueAxios, axios);

Vue.use(VueGtag, {
    config: { id: 'UA-87133451-14' },
    includes: [
        { id: 'AW-800909326' },
    ],
}, router);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
